var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.restaurantIds)?_c('empty-state',{attrs:{"icon":"mdi-truck-delivery","title":_vm.$t('select_restaurant'),"subtitle":_vm.$t('please_select_restaurant_to_view_data')}}):_c('companies-delivery-table',{attrs:{"data":_vm.filteredData,"loading":_vm.isLoading,"search-query":_vm.searchQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }